/**
 * Mongoose `populate` means an id field arrives either as a string or as a
 * partial document, depending on which endpoint served it — `/vehicles/live`
 * returns a raw `deviceId`, while `/vehicles` populates the same field with
 * `{ imei, model, status }`. Every read of such a field goes through here so a
 * component never has to know which endpoint it came from.
 */
export type Ref<T> = string | (Partial<T> & { id: string }) | null;

export function refId(ref: Ref<unknown> | undefined): string | null {
  if (!ref) return null;
  if (typeof ref === 'string') return ref;
  return ref.id ?? null;
}

/** The populated document, or null when only an id was sent. */
export function refDoc<T>(ref: Ref<T> | undefined): (Partial<T> & { id: string }) | null {
  if (!ref || typeof ref === 'string') return null;
  return ref;
}

export function sameRef(ref: Ref<unknown> | undefined, id: string | null | undefined): boolean {
  return id !== null && id !== undefined && refId(ref) === id;
}
